<div
  class="flex flex-col w-screen max-w-90 bg-card rounded-2xl shadow-lg overflow-hidden"
  role="dialog"
  aria-labelledby="bp-notification-panel-title"
>
  <!-- Encabezado -->
  <div class="flex items-center justify-between gap-2 px-5 py-4 border-b">
    <h3
      #panelTitle
      id="bp-notification-panel-title"
      tabindex="-1"
      class="text-base font-semibold leading-6 tracking-tight outline-none"
    >
      Notificaciones
    </h3>

    <button
      type="button"
      mat-button
      class="text-sm"
      (click)="markAllAsRead()"
      [disabled]="isLoading() || !canMarkAll()"
    >
      Marcar todas como leídas
    </button>
  </div>

  <!-- Contenido -->
  <div class="flex flex-col max-h-96 overflow-y-auto">
    @if (isLoading()) {
      <div class="flex flex-col gap-4 px-5 py-4">
        @for (placeholder of [1, 2, 3]; track placeholder) {
          <span [bp-skeleton]="isLoading()" skeletonWidth="full" skeletonHeight="4"></span>
        }
      </div>
    } @else if (hasError()) {
      <p class="px-5 py-8 text-sm text-center text-secondary">
        No pudimos cargar las notificaciones. Inténtalo de nuevo.
      </p>
    } @else if (items().length === 0) {
      <p class="px-5 py-8 text-sm text-center text-secondary">No tienes notificaciones</p>
    } @else {
      @for (notification of items(); track notification.id) {
        <button
          type="button"
          class="w-full px-5 py-3 text-left border-b hover:bg-gray-50 last:border-b-0"
          (click)="open(notification)"
        >
          <bp-notification-row [notification]="notification"></bp-notification-row>
        </button>
      }
    }
  </div>

  <!-- Pie: enlaces de texto del catálogo (`bp-link`), 070 T048 -->
  <div class="flex items-center justify-between gap-2 px-5 py-3 border-t">
    <a bp-link [routerLink]="['/notificaciones']" (click)="closed.emit()">Ver todas</a>
    <a bp-link [routerLink]="['/notificaciones/preferencias']" (click)="closed.emit()"
      >Preferencias</a
    >
  </div>
</div>
